
import { JSX } from "react";

// Table
import { CellContext } from "@tanstack/react-table";
import { EditAbleCell } from "./styledTableCell";
import { IdentifiableRow } from "../reactiveTableRenderer";

export const ButtonTableCell = <T extends IdentifiableRow,> ({getValue, row, table, column, canEdit, staticColumn, divStyleOverride, styleOverrideOnValue = true, cell}: CellContext<T, JSX.Element> & EditAbleCell<T>) => {
  const isStatic = typeof staticColumn === "function" ? staticColumn(row) : staticColumn;
  return canEdit || isStatic ? (
    <div >
      {getValue()}
    </div>
  ) : (<div/>)

}

